import { render, staticRenderFns } from "./EditStep1.vue?vue&type=template&id=5083ddd6&scoped=true&"
import script from "./EditStep1.vue?vue&type=script&lang=js&"
export * from "./EditStep1.vue?vue&type=script&lang=js&"
import style1 from "./EditStep1.vue?vue&type=style&index=1&id=5083ddd6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5083ddd6",
  null
  
)

export default component.exports